export const config = {
    progressCounterHueRange: 51,
    durationInMili: 30000,
    updateOpenBetsInterval: 60000,
    openMyPulseBetsDelay: 2000,
    trackColor: { start: { r: 245, g: 145, b: 32, a: 1 }, end: { r: 242, g: 0, b: 0, a: 1 } },
    removeBetIntervalInMilli: 10000,
    redirectToDefaultGroupDelay: 5000
}